import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

interface LayoutProps {
  isPlatformAdmin: boolean;
}

export default function Layout({ isPlatformAdmin }: LayoutProps) {
  return (
    <div className="h-full flex" style={{ background: '#0c1829' }}>
      <Sidebar isPlatformAdmin={isPlatformAdmin} />

      {/* Main content area */}
      <main className="flex-1 flex flex-col overflow-hidden bg-surface-900">
        {/* Subtle grid background for mission-control feel */}
        <div className="flex-1 overflow-y-auto relative">
          <div
            className="absolute inset-0 pointer-events-none opacity-[0.015]"
            style={{
              backgroundImage:
                'linear-gradient(rgba(59,130,246,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.3) 1px, transparent 1px)',
              backgroundSize: '60px 60px',
            }}
          />
          <div className="relative z-10 p-6">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
